// Rosh whitelabel: identificação e tinta dos canais.
//
// O mockup aprovado usa glifos monocromáticos tingidos com a cor da marca
// (estilo "vetor"), em vez dos logos oficiais multicoloridos. As cores vivem
// em `--rosh-whatsapp` / `--rosh-gmail` (_next-colors.scss), então ajustar a
// paleta é mexer em um lugar só.

const TINTS = {
  whatsapp: {
    icon: 'text-n-rosh-whatsapp',
    chip: 'text-n-rosh-whatsapp bg-n-rosh-whatsapp/10',
  },
  email: {
    icon: 'text-n-rosh-gmail',
    chip: 'text-n-rosh-gmail bg-n-rosh-gmail/10',
  },
  web: { icon: 'text-n-blue-9', chip: 'text-n-blue-11 bg-n-blue-3' },
  other: { icon: 'text-n-slate-11', chip: 'text-n-slate-11 bg-n-alpha-2' },
};

// Aceita as duas formas do objeto inbox: `channel_type` (store) e
// `channelType` (card de conversa).
export const roshChannelKind = inbox => {
  const type = inbox?.channel_type || inbox?.channelType || '';
  const name = inbox?.name || '';

  // A Evolution entra por canal de API genérico, então o tipo não diz que é
  // WhatsApp — o nome da inbox é a única pista disponível.
  if (
    type === 'Channel::Whatsapp' ||
    (type === 'Channel::Api' && /whats\s*app/i.test(name))
  ) {
    return 'whatsapp';
  }
  if (type === 'Channel::Email') return 'email';
  if (type === 'Channel::WebWidget') return 'web';
  return 'other';
};

export const roshChannelIconClass = inbox => TINTS[roshChannelKind(inbox)].icon;

export const roshChannelChipClass = inbox => TINTS[roshChannelKind(inbox)].chip;
